export const WIDGET_URL = process.env.REACT_APP_WIDGET_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const USER_TYPE = process.env.REACT_APP_USER_TYPE;

export const UserType = {
  COPMLIANCE: "Compliance",
  ADMIN: "Admin",
};

export const KeyboardEventKey = { ENTER: "Enter", ESC: "Escape" };
